import {
  ITEMAUTOTOPUPBILLING,
  ITEMTRANSACTIONAUTO,
  RESPONSEAUTOVALIDCUSTOMER,
  RESPONSECREATEAUTO,
} from "app/shared/services/services-model.type";
import { FormAutoBillingFilterHistory } from "../auto-history/filter-history-table/filter-history";
import {
  SET_AUTO_BILLING_STORE,
  SET_AUTO_BILLING_RESET,
  FETCH_AUTO_BILLING_LIST_REQUEST,
  FETCH_AUTO_BILLING_LIST_SUCCESS,
  FETCH_AUTO_BILLING_LIST_FAILURE,
  FETCH_AUTO_BILLING_DELETE_REQUEST,
  FETCH_AUTO_BILLING_DELETE_SUCCESS,
  FETCH_AUTO_BILLING_DELETE_FAILURE,
  FETCH_AUTO_BILLING_VALID_CUSTOMER_REQUEST,
  FETCH_AUTO_BILLING_VALID_CUSTOMER_SUCCESS,
  FETCH_AUTO_BILLING_VALID_CUSTOMER_FAILURE,
  FETCH_AUTO_BILLING_CREATE_REQUEST,
  FETCH_AUTO_BILLING_CREATE_SUCCESS,
  FETCH_AUTO_BILLING_CREATE_FAILURE,
  FETCH_AUTO_BILLING_AUTHORIZATION_KEY_REQUEST,
  FETCH_AUTO_BILLING_AUTHORIZATION_KEY_SUCCESS,
  FETCH_AUTO_BILLING_AUTHORIZATION_KEY_FAILURE,
  FETCH_AUTO_BILLING_TRANSACTION_REQUEST,
  FETCH_AUTO_BILLING_TRANSACTION_SUCCESS,
  FETCH_AUTO_BILLING_TRANSACTION_FAILURE,
} from "./actions.type";
import {
  DataAutoBillingCreate,
  SetAutoBillingStore,
  AutoBillingState,
  SetAutoBillingReset,
  FetchAutoBillingListRequest,
  FetchAutoBillingListSuccess,
  FetchAutoBillingListFailure,
  FetchAutoBillingDeleteRequest,
  FetchAutoBillingDeleteSuccess,
  FetchAutoBillingDeleteFailure,
  FetchAutoBillingValidCustomerRequest,
  FetchAutoBillingValidCustomerSuccess,
  FetchAutoBillingValidCustomerFailure,
  FetchAutoBillingCreateRequest,
  FetchAutoBillingCreateSuccess,
  FetchAutoBillingCreateFailure,
  FetchAutoBillingAuthorizationRequest,
  FetchAutoBillingAuthorizationSuccess,
  FetchAutoBillingAuthorizationFailure,
  FetchAutoBillingTransactionRequest,
  FetchAutoBillingTransactionSuccess,
  FetchAutoBillingTransactionFailure,
} from "./types";

export const fetchAutoBillingListRequest = (payload?: string): FetchAutoBillingListRequest => ({
  type: FETCH_AUTO_BILLING_LIST_REQUEST,
  payload,
});

export const fetchAutoBillingListSuccess = (payload?: ITEMAUTOTOPUPBILLING[]): FetchAutoBillingListSuccess => ({
  type: FETCH_AUTO_BILLING_LIST_SUCCESS,
  payload,
});

export const fetchAutoBillingListFailure = (payload?: string): FetchAutoBillingListFailure => ({
  type: FETCH_AUTO_BILLING_LIST_FAILURE,
  payload,
});

export const fetchAutoBillingDeleteRequest = (payload?: ITEMAUTOTOPUPBILLING): FetchAutoBillingDeleteRequest => ({
  type: FETCH_AUTO_BILLING_DELETE_REQUEST,
  payload,
});

export const fetchAutoBillingDeleteSuccess = (payload?: RESPONSEAUTOVALIDCUSTOMER): FetchAutoBillingDeleteSuccess => ({
  type: FETCH_AUTO_BILLING_DELETE_SUCCESS,
  payload,
});

export const fetchAutoBillingDeleteFailure = (payload?: string): FetchAutoBillingDeleteFailure => ({
  type: FETCH_AUTO_BILLING_DELETE_FAILURE,
  payload,
});

export const fetchAutoBillingValidCustomerRequest = (payload?: DataAutoBillingCreate): FetchAutoBillingValidCustomerRequest => ({
  type: FETCH_AUTO_BILLING_VALID_CUSTOMER_REQUEST,
  payload,
});

export const fetchAutoBillingValidCustomerSuccess = (
  payload?: RESPONSEAUTOVALIDCUSTOMER,
  data?: DataAutoBillingCreate,
): FetchAutoBillingValidCustomerSuccess => ({
  type: FETCH_AUTO_BILLING_VALID_CUSTOMER_SUCCESS,
  payload,
  data,
});

export const fetchAutoBillingValidCustomerFailure = (payload?: string): FetchAutoBillingValidCustomerFailure => ({
  type: FETCH_AUTO_BILLING_VALID_CUSTOMER_FAILURE,
  payload,
});

export const fetchAutoBillingCreateRequest = (payload?: DataAutoBillingCreate): FetchAutoBillingCreateRequest => ({
  type: FETCH_AUTO_BILLING_CREATE_REQUEST,
  payload,
});

export const fetchAutoBillingCreateSuccess = (payload?: RESPONSECREATEAUTO): FetchAutoBillingCreateSuccess => ({
  type: FETCH_AUTO_BILLING_CREATE_SUCCESS,
  payload,
});

export const fetchAutoBillingCreateFailure = (payload?: string): FetchAutoBillingCreateFailure => ({
  type: FETCH_AUTO_BILLING_CREATE_FAILURE,
  payload,
});

export const fetchAutoBillingAuthorizationRequest = (
  payload?: RESPONSECREATEAUTO,
  code?: string,
): FetchAutoBillingAuthorizationRequest => ({
  type: FETCH_AUTO_BILLING_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchAutoBillingAuthorizationSuccess = (payload?: any): FetchAutoBillingAuthorizationSuccess => ({
  type: FETCH_AUTO_BILLING_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchAutoBillingAuthorizationFailure = (errorOTP: boolean, payload?: string): FetchAutoBillingAuthorizationFailure => ({
  type: FETCH_AUTO_BILLING_AUTHORIZATION_KEY_FAILURE,
  errorOTP,
  payload,
});

export const fetchAutoBillingTransactionRequest = (payload?: FormAutoBillingFilterHistory): FetchAutoBillingTransactionRequest => ({
  type: FETCH_AUTO_BILLING_TRANSACTION_REQUEST,
  payload,
});

export const fetchAutoBillingTransactionSuccess = (payload?: ITEMTRANSACTIONAUTO[]): FetchAutoBillingTransactionSuccess => ({
  type: FETCH_AUTO_BILLING_TRANSACTION_SUCCESS,
  payload,
});

export const fetchAutoBillingTransactionFailure = (payload?: string): FetchAutoBillingTransactionFailure => ({
  type: FETCH_AUTO_BILLING_TRANSACTION_FAILURE,
  payload,
});

export const setAutoBillingStore = (payload: AutoBillingState): SetAutoBillingStore => ({
  type: SET_AUTO_BILLING_STORE,
  payload,
});

export const setAutoBillingReset = (): SetAutoBillingReset => ({
  type: SET_AUTO_BILLING_RESET,
});
